import type { ReactNode } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

type ChartCardProps = {
  title: string;
  children: ReactNode;
  description?: string;
};

export function ChartCard({ title, children, description }: ChartCardProps) {
  return (
    <Card className="break-inside-avoid">
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent
        className="h-64 overflow-hidden p-0 pb-2"
        role="img"
        aria-label={description ?? title}
      >
        {children}
      </CardContent>
    </Card>
  );
}
